import { faBan, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import i18n from "../../../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";
import { getFormmatedDate } from "../../../../../../../helpers/et3-date-helper";
import getKhattabat102Store from "../../../../../../../stores/khattabat-stores/102-stores";
import { isNullOrUndefined } from "et3-type-guards";

const OneOTwoMessageHiddenIndicator = withLiteObserverAndTheme<{
  conversationID: string;
  messageId: number;
}>((props) => {
  const { conversationID, messageId, theme } = props;
  const { colors, unitX } = theme;

  const khattabat102Store = getKhattabat102Store(conversationID);
  const currentHiddenAction =
    khattabat102Store.getCurrentMessageHiddenAction(messageId);

  if (isNullOrUndefined(currentHiddenAction)) {
    return null;
  }

  const isHiddenForEveryone =
    khattabat102Store.getIsMessageHiddenForEveryone(messageId);

  const iconColor = isHiddenForEveryone ? colors.all.vividRed : colors.all.orange;

  const [hiddenOnDate, hiddenOnTime] = getFormmatedDate(
    new Date(currentHiddenAction.hiddenOn)
  ).split(" ");

  return (
    <div
      title={i18n.get(
        isHiddenForEveryone
          ? "KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE_FOR_EVERYONE"
          : "KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE_FOR_ME"
      )}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "fit-content"
      }}
    >
      <FontAwesomeIcon
        icon={isHiddenForEveryone ? faBan : faEyeSlash}
        color={iconColor}
        style={{ width: 22.4 * unitX, height: 22.4 * unitX }}
      />

      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={14}
        isSpan={false}
        text={hiddenOnDate}
        color={colors.all.davysGrey}
        style={{ margin: 0, whiteSpace: "nowrap" }}
      />

      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={14}
        isSpan={false}
        text={hiddenOnTime}
        color={colors.all.davysGrey}
        style={{ margin: 0, whiteSpace: "nowrap" }}
      />
    </div>
  );
});

export default OneOTwoMessageHiddenIndicator;
